import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function MobileHero() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 4
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="relative bg-[#FAF0E6] w-full min-h-[100svh] flex flex-col items-center" data-id="element-274">
      {/* Background Organic Shapes */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-275">
        <div className="absolute top-[-10%] left-[-20%] w-[150%] h-[60%] bg-sage-light/20 blur-[100px] rounded-[100%] animate-pulse" style={{
        animationDuration: '8s'
      }} data-id="element-276"></div>
        <div className="absolute bottom-[-10%] right-[-20%] w-[120%] h-[50%] bg-lavender/15 blur-[80px] rounded-[100%] animate-pulse" style={{
        animationDuration: '10s'
      }} data-id="element-277"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 w-full max-w-[480px] flex flex-col items-center text-center px-5 pt-3 pb-4 md:py-12 justify-evenly h-[100svh] md:h-auto md:min-h-[100svh] md:justify-center md:gap-6" data-id="element-278">
        {/* Element 1: Top Micro Label */}
        <div className="flex flex-col items-center" data-id="element-279">
          <p className="font-sans font-medium text-[10px] text-sage tracking-[4px] uppercase opacity-80" data-id="element-280">
            🌙 MENTE EN SILENCIO™
          </p>
          <div className="w-8 h-[1px] bg-gold/40 mt-1" data-id="element-281"></div>
        </div>

        {/* Element 2: Main Headline */}
        <h1 className="font-display font-bold text-[29px] md:text-[32px] leading-[1.12] text-navy flex flex-col items-center tracking-tight" data-id="element-282">
          <span data-id="element-283">Apagá la mente</span>
          <span data-id="element-284">y dormí profundo</span>
          <span className="inline-block" data-id="element-285">
            en{' '}
            <span className="relative inline-block italic" data-id="element-286">
              11 minutos
              <span className="absolute -bottom-0.5 left-0 w-full h-[5px] bg-gold/30 -z-10 rounded-full" data-id="element-287"></span>
            </span>
          </span>
          <span className="text-sage relative inline-block" data-id="element-288">
            esta noche
            <span className="absolute -bottom-0.5 left-0 w-full h-[2px] bg-sage/40" data-id="element-289"></span>
          </span>
        </h1>

        {/* Element 3: Subheadline */}
        <p className="font-sans font-normal text-[13px] md:text-[15px] leading-[1.4] text-dark-muted max-w-[300px] md:max-w-[320px]" data-id="element-290">
          Un método basado en neurociencia para{' '}
          <span className="font-medium text-sage border-b border-sage/30" data-id="element-291">
            vaciar la mente
          </span>
          ,{' '}
          <span className="font-medium text-sage border-b border-sage/30" data-id="element-292">
            cortar la rumiación
          </span>{' '}
          y{' '}
          <span className="font-medium text-sage border-b border-sage/30" data-id="element-293">
            recuperar el sueño
          </span>
          .
        </p>

        {/* Element 4: Product Mockup Image */}
        <div className="relative w-full max-w-[230px] md:max-w-[260px] flex justify-center" data-id="element-294">
          <div className="relative w-full" data-id="element-295">
            <img src="https://cdn.magicpatterns.com/uploads/4SyLzJSDfRsRZbVMjDpizZ/mente_en_silencio_mockup2_1280.webp" alt="Mente en Silencio Mockup Completo" className="w-full h-auto rounded-lg shadow-[0_20px_50px_-15px_rgba(27,42,74,0.25)]" style={{
            maskImage: 'radial-gradient(circle, black 75%, transparent 100%)',
            WebkitMaskImage: 'radial-gradient(circle, black 75%, transparent 100%)'
          }} data-id="element-296" />
            <div className="absolute inset-0 bg-gold/5 blur-3xl -z-10 rounded-full scale-90" data-id="element-297"></div>
          </div>
        </div>

        {/* Element 5: Promise Statement (Pills) */}
        <div className="flex flex-wrap justify-center gap-1.5 md:gap-2" data-id="element-298">
          {['Sin pastillas.', 'Sin esfuerzo.', 'Solo el sistema.'].map((text, i) => <div key={i} className="bg-white/60 backdrop-blur-sm border border-sage-light/40 rounded-full px-3 py-1 md:px-4 md:py-1.5 shadow-sm" data-id="element-299">
                <p className="font-sans font-medium text-[10px] md:text-[11px] text-sage tracking-wide" data-id="element-300">
                  {text}
                </p>
              </div>)}
        </div>

        {/* Element 6: Primary CTA Button */}
        <div className="w-full flex flex-col items-center gap-2 md:gap-4" data-id="element-301">
          <motion.a href="#pricing" animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.05,
          backgroundColor: '#FAD4A6'
        }} whileTap={{
          scale: 0.98
        }} className="w-full max-w-[320px] bg-gold text-sage-dark font-sans font-bold text-[15px] md:text-[16px] py-[14px] md:py-[18px] px-6 rounded-full uppercase tracking-[2px] shadow-[0_10px_25px_-5px_rgba(250,212,166,0.5)] transition-all duration-300 flex items-center justify-center" data-id="element-302">
            → EMPEZAR ESTA NOCHE
          </motion.a>

          {/* Element 7: Trust Badges Row */}
          <div className="flex items-center justify-center gap-3 text-taupe font-sans text-[10px] md:text-[11px] tracking-wider font-medium opacity-80" data-id="element-303">
            <span className="uppercase" data-id="element-304">100% PDF</span>
            <span className="w-1 h-1 bg-gold rounded-full opacity-40" data-id="element-305"></span>
            <span className="uppercase" data-id="element-306">Acceso en 5 min</span>
            <span className="w-1 h-1 bg-gold rounded-full opacity-40" data-id="element-307"></span>
            <span className="uppercase" data-id="element-308">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}